import { CSSProperties, PropsWithChildren, SyntheticEvent } from 'react'

import ClassNameBuilder from '../../../tools/ClassNameBuilder'

type ContainerArrangement = 'spaced' | 'start' | 'center' | 'end'
type ContainerAlignment = 'start' | 'center' | 'end'

// Allowed gap sizes in rem.
type rem = 0 | 0.25 | 0.5 | 0.75 | 1 | 1.5 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export interface ContainerProps extends PropsWithChildren {
    tag?: keyof HTMLElementTagNameMap
    className?: string
    style?: CSSProperties
    onClick?: (event: SyntheticEvent) => void
    onClickCapture?: (event: SyntheticEvent) => void
    gap?: rem
    grow?: boolean
    wide?: boolean
    tall?: boolean
    scroll?: boolean
    container?: boolean
    relative?: boolean
    arrangement?: ContainerArrangement
    alignment?: ContainerAlignment
}

export const Column = (props: ContainerProps) => <FlexContainer {...props} type="column" />
export const Row = (props: ContainerProps) => <FlexContainer {...props} type="row" />

interface FlexContainerProps extends ContainerProps {
    type: 'row' | 'column'
}

function FlexContainer({
    type,
    tag,
    className,
    children,
    gap,
    grow,
    wide,
    tall,
    scroll,
    container,
    relative,
    arrangement,
    alignment,
    ...props
}: FlexContainerProps) {
    const classNames = new ClassNameBuilder()
        .add('flex-container')
        .add(type)
        .addIf('gap-' + gap?.toString().replace('.', ''), !!gap)
        .addIf('grow', grow)
        .addIf('wide', wide)
        .addIf('tall', tall)
        .addIf('scroll', scroll)
        .addIf('container', container)
        .addIf('relative', relative)
        .addIf('arrangement-' + arrangement, !!arrangement)
        .addIf('alignment-' + alignment, !!alignment)
        .add(className)
    // NOTE: Provide dynamic tag name using capitalized variable.
    const Tag = tag ?? 'div'
    return (
        <Tag className={classNames.toString()} {...props}>
            {children}
        </Tag>
    )
}
